// extracted by mini-css-extract-plugin
export default {"editorWidthTitle":"editorWidthTitle__cva25A","editorWidthSelector":"editorWidthSelector__TkB6HW","editorWidthButton":"editorWidthButton__s81OE1"};